import { ItemImage } from '@/api';
import { ProductPageGallery, ProductPageGalleryItem } from '@/components/general/ProductPageGallery';
import If from '@/components/util/IF';
import { useHasWindow } from '@/hooks/useHasWindow';
import useItemContext from '@/hooks/useItemContext';
import React from 'react';

type ProductListingGalleryProps = {
    isEverythingLoaded: boolean;
    setIndex: (index: number) => void;
};

const ProductListingGallery = (props: ProductListingGalleryProps) => {
    const { isEverythingLoaded, setIndex } = props;
    const { item } = useItemContext();
    const hasWindow = useHasWindow();

    return (
        <div className="flex items-center md:mr-[40px] mr-[0] w-full">
            <div className=" bg-grey11 md:bg-white md:border-none px-4 md:px-0 border-b-[1px] mb-[24px] md:mb-0 w-full">
                <ProductPageGallery<ItemImage>
                    items={isEverythingLoaded && item ? item.images : [{ id: 'item-1' }, { id: 'item-2' }, { id: 'item-3' }] as ItemImage[]}
                    activeNavColor="#98A2B3"
                    isLoading={!isEverythingLoaded}
                    key={item?.id}
                    renderItem={({
                        item: renderItem,
                        index: itemIindex,
                        isSnapPoint,
                    }) => (
                        <ProductPageGalleryItem
                            className="cursor-nesw-resize"
                            key={renderItem.id}
                            isSnapPoint={isSnapPoint}
                            fullWidth
                            onClick={() => setIndex(itemIindex)}
                        >
                            <If condition={renderItem.type === ItemImage.TypeEnum.Image}>
                                <img className="self-center absolute h-full z-0 inset-0 blur-3xl transform-cpu touch-none" style={{ transform: 'translate3d(0,0,0)' }} src={renderItem.url} alt="" />
                                <img className="self-center z-10" src={renderItem.url} alt="" />
                            </If>
                            <If condition={[renderItem.type === ItemImage.TypeEnum.Video, hasWindow]}>
                                <video preload="auto" autoPlay playsInline controls={false} loop muted className="self-center" src={renderItem.url} />
                            </If>
                        </ProductPageGalleryItem>
                    )}
                />
            </div>
        </div>
    );
};

export default ProductListingGallery;
